/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Collaborators_Invitecollaboratoremail2Inputs */

const en_settings_collaborators_invitecollaboratoremail2 = /** @type {(inputs: Settings_Collaborators_Invitecollaboratoremail2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Collaborator email`)
};

/**
* | output |
* | --- |
* | "Collaborator email" |
*
* @param {Settings_Collaborators_Invitecollaboratoremail2Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const settings_collaborators_invitecollaboratoremail2 = /** @type {((inputs?: Settings_Collaborators_Invitecollaboratoremail2Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Collaborators_Invitecollaboratoremail2Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_settings_collaborators_invitecollaboratoremail2(inputs)
});
export { settings_collaborators_invitecollaboratoremail2 as "settings_collaborators_inviteCollaboratorEmail" }